export default (description, guid) => {
	return {
		errorDescription: description,
		blockGuid: guid,
	};
};
